import { AuxiliumComponent } from "../auxilium-component";

export class TabGroup extends AuxiliumComponent {
	static observedAttributes = ["is-dynamic", "orientation", "direction"];

	constructor() {
		super();

		this.variation = this.getAttribute("variation");
		this.orientation = this.getAttribute("orientation") ?? "";
		this.isDynamic = this.hasAttribute("is-dynamic");
		this.scroll = this.hasAttribute("scroll");
		this.preventButtons = this.hasAttribute("prevent-buttons") ?? false;
		this.direction = this.getAttribute("direction") ?? "";
		this.selectedIndex = 0;
	}

	parsedCallback() {
		if (!this.querySelector(":scope > .tab-group__tabs > .tab__wrapper > chip-tab[selected]")) {
			this.querySelector("chip-tab").selected = true;
		}

		const content = document.createElementWithContents("div", null, { className: "tab-group__content" }),
			selectedIndex = [...this.children].indexOf(this.querySelector("chip-tab[selected]")),
			actionContent = this.querySelectorAll(":scope > *:not(chip-tab)");

		this.querySelectorAll(":scope > chip-tab").forEach((tab, index, self) => {
			const newTab = document.createElementWithContents("div", tab.childNodes, { className: "tab-group__tab" });

			if (this.variation === "steps") {
				newTab.prepend(document.createElementWithContents("div",
					`
					<div class="mobile-header__title">Step ${index + 1} of ${self.length}</div>
					<div class="mobile-header__subtitle">${tab.getAttribute("label")}</div>
				`.trim(), {
					className: "tab__mobile-header"
				}));
			}

			content.appendChild(newTab);
		});

		this.appendChild(content);

		this.prepend(document.createElementWithContents("div", document.createElementWithContents("div", this.querySelectorAll(":scope > chip-tab"), { className: "tab__wrapper" }), {
			className: "tab-group__tabs"
		}));

		if (actionContent.length) {
			this.querySelector(".tab-group__tabs").appendChild(document.createElementWithContents("div", actionContent, { className: "nav__actions" }));
		}

		this.querySelector(`.tab-group__tab:nth-child(${selectedIndex + 1})`)?.classList.add("selected");
	}

	GetSelectedContent = () => this.querySelector(`.tab-group__tab:nth-child(${this.selectedIndex + 1})`);
	selectIndex = index => this.querySelector(`chip-tab:nth-child(${index + 1})`).selected = true;

	GetSelectedTab = () => this.querySelector("chip-tab[selected]") ?? this.querySelector(`chip-tab:nth-child(${this.selectedIndex + 1})`) ?? this.querySelector("chip-tab");

	AddTab(label, content, options) {
		const tab = document.createElementWithContents("chip-tab", null, { label, selected: true, ...options }),
			contentDiv = document.createElementWithContents("div", content, { className: "tab-group__tab" });

		this.querySelector("chip-tab:last-of-type")?.insertAdjacentElement("afterend", tab);
		this.querySelector(".tab-group__content")?.appendChild(contentDiv);

		if (this.querySelector(":scope > .tab-group__tabs > .tab__wrapper > chip-tab:not(:last-child)")) {
			this.querySelectorAll(":scope > .tab-group__tabs > .tab__wrapper > chip-tab").forEach(tab => {
				if (tab._allowClose) {
					tab.allowClose = true;
				}
			})
		}

		setTimeout(() => {
			const tabWrapper = this.querySelector(".tab-group__tabs");

			if (tabWrapper) {
				tabWrapper.scrollTo({
					left: tabWrapper.scrollWidth,
					behavior: 'smooth'
				});
			}
		}, 0);

		return tab;
	}
}